import ServiceBusController from "servicestack/service-bus.controller";
import layouts from "servicestack/tags/navigator/tag-navigator.layouts";
import templateUrl from "servicestack/tags/navigator/tag-navigator-demo.htm";

class TagNavigatorDemoController extends ServiceBusController {
  $onInit(...args) {
    this.print("$onInit", args);
    this.navs = ["Brand", "Collection", "RoomType"];
    this.layouts = Object.keys(layouts);
    this.layout = this.layouts[3];
    this.colSplit = 0;
    this.maxColumnWidth = 180;
    this.maxHeight = 550;
    this.url = "QueryProductTagTotals.json";
    this.viewAllLabel = "View All...";
    this.bus
      .send("QueryProductTagKinds.json")
      .then(r =>
        console.debug(
          "QueryProductTagKinds.json",
          (this.tagKinds = r.data.results.map(m => `${m.tagKind}: ${m.count}`))
        )
      );
  }

  $onChanges(...args) {
    this.print("$onChanges", args);
  }

  onLoaded(...args) {
    this.print("$onLoaded", args);
  }

  onClose(...args) {
    this.print("$onClose", args);
  }

  onCleared(...args) {
    this.print("$onCleared", args);
  }

  onDrilledDown(...args) {
    this.print("$onDrilledDown", args);
  }

  onSelected(...args) {
    this.print("$onSelected", args);
  }

  print(msg, args) {
    console.debug(msg, { that: this, msg, args });
    this.output = { msg, args };
  }

  codeBlock() {
    return `
<tag-navigator
  navs='${JSON.stringify(this.navs)}'
  layout="${this.layout}"
  view-all-label="${this.viewAllLabel}"
  tag-totals-url="${this.url}"
  max-column-width="${this.maxColumnWidth}"
  max-height="${this.maxHeight}"
>
</tag-navigator>    
    `;
  }
}

export default {
  bindings: {},
  controller: TagNavigatorDemoController,
  templateUrl
};
